import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchNewsItemByIdAction } from './actions/fetchNewsItemById';

import { withRouter } from 'react-router';

import {NewsPage} from './newsPage';

const mapStateToProps = (state: IState, ownProps: any) => ({
    newsItem: state.eventsAndNewsItems.latestSelectedNewsItem,
    newsItemId: ownProps.params.id
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchNewsItemById: (id: string) => dispatch(fetchNewsItemByIdAction(id))
});

export const NewsPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NewsPage));


// WEBPACK FOOTER //
// ./src/components/newsPage/newsPageContainer.tsx